import { AppPropsWithLayout } from 'utils/nextTypes';

import { App } from './_app';

function AccountApp(props: AppPropsWithLayout) {
  return <App {...props} userLoaded />;
}

export default AccountApp;
